import { useLocation, useNavigate } from 'react-router';
import { Button, Tabs } from '@indipia/ui-core';

const BASE = '/agents/work-log';

// D-07 §20.1 icon-sm(16)
const ClockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

/**
 * 작업요청 등록 화면 상단 탭 + 발송이력 바로가기(실측 화면 기준).
 * 탭은 등록 모드 2개(공종별/일괄)만 — "발송이력"은 모드가 아니라 별도 코너 버튼으로 둔다.
 */
export function WorkOrderTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const value = pathname.endsWith('/workorder/bulk') ? 'bulk' : 'new';

  return (
    // 좁은 폭: 탭 라벨은 한 줄 유지(넘치면 가로 스크롤), 발송이력 버튼은 다음 줄로 내린다.
    <div className="flex shrink-0 flex-wrap items-center justify-between gap-x-sm border-b border-border px-06">
      <Tabs
        variant="line"
        className="min-w-0 overflow-x-auto whitespace-nowrap"
        value={value}
        onChange={(v) => {
          if (v === value) return;
          navigate(`${BASE}/workorder/${v}`);
        }}
        tabs={[
          { label: '공종별 작업요청', value: 'new' },
          { label: '일괄 작업요청', value: 'bulk' },
        ]}
      />
      {/* 뉴트럴·기타 액션(D-09 §15.1 .btn-etc) — 카테고리 이동이라 primary/secondary(groupTheme 강조)와 구분 */}
      <Button variant="etc" size="sm" onClick={() => navigate(`${BASE}/workorder`)}>
        <ClockIcon />
        작업요청 발송이력
      </Button>
    </div>
  );
}
